import React from "react";
import _ from "lodash";
import { TableCell, TableRow } from "@material-ui/core";
import numberFormatter from "utils/numberFormatter";
import moment from "moment";
import { map } from "constants/screenElements/pipelineDealTable";
import PipelineDealTableMetricFormatter from "components/Global/Metric/PipelineDealTableMetricFormatter";

const getMetricValue = (deal, metricId) => PipelineDealTableMetricFormatter[metricId](_.get(deal, metricId));
const PipelineDealTileRows = () => [
  {
    id: "7d8f2642-3f5e-11e9-bf92-0242ac140002",
    isBaseColumn: false,
    dataField: "targetedClosing",
    numeric: false,
    label: "Targeted Close",
    Cell: ({ deal: { targetedClosing } }) => (
      <TableRow>
        <TableCell>Targeted Close</TableCell>
        <TableCell>{targetedClosing ? moment(targetedClosing).format("L") : "\u2014"}</TableCell>
      </TableRow>
    )
  },
  {
    id: "7d8f25cf-3f5e-11e9-bf92-0242ac140002",
    isBaseColumn: false,
    dataField: "stageId",
    numeric: false,
    label: "Stage",
    Cell: ({
      deal: {
        stage
      }
    }) => <TableRow>
      <TableCell>Stage</TableCell>
      <TableCell>{stage ? stage.value : "\u2014"}</TableCell>
          </TableRow>
  },
  {
    id: "7d8f2560-3f5e-11e9-bf92-0242ac140002",
    isBaseColumn: false,
    dataField: "fund.name",
    numeric: false,
    label: "Group",
    Cell: ({
      deal: {
        fund
      }
    }) => <TableRow>
      <TableCell>Group</TableCell>
      <TableCell>{fund ? fund.name : "\u2014"}</TableCell>
          </TableRow>
  },
  {
    id: map.DESIRED_LOAN_AMOUNT,
    isBaseColumn: false,
    dataField: "desiredLoanAmount",
    numeric: false,
    label: "Desired Loan Amount",
    Cell: ({ deal: { desiredLoanAmount } }) => (
      <TableRow>
        <TableCell>Desired Loan Amount</TableCell>
        <TableCell>{numberFormatter.maskCurrency(desiredLoanAmount)}</TableCell>
      </TableRow>
    )
  },
  {
    id: map.APPRAISED_VALUE,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Appraised Value",
    Cell: data => {
      const value = getMetricValue(data.deal, map.APPRAISED_VALUE);

      return (<TableRow>
        <TableCell>Appraised Value</TableCell>
        <TableCell>{value}</TableCell>
              </TableRow>);
    }
  },
  {
    id: map.SALES_PRICE,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Sales Price",
    Cell: data => {
      const value = getMetricValue(data.deal, map.SALES_PRICE);

      return (<TableRow>
        <TableCell>Sales Price</TableCell>
        <TableCell>{value}</TableCell>
      </TableRow>);
    }
  },
  {
    id: map.BROKER_COMPANY,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Broker Company",
    Cell: data => {
      const brokerCompany = _.get(data, "deal.brokerCompany.name", "--");

      return (<TableRow>
        <TableCell>Broker</TableCell>
        <TableCell>{brokerCompany}</TableCell>
      </TableRow>);
    }
  },
  {
    id: map.NOI,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "NOI",
    Cell: data => {
      const value = getMetricValue(data.deal, map.NOI);

      return (
        <TableRow>
          <TableCell>NOI</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>
      );
    }
  },
  {
    id: map.OCCUPANCY,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Occupancy",
    Cell: data => {
      const value = getMetricValue(data.deal, map.OCCUPANCY);

      return (
        <TableRow>
          <TableCell>Occupancy</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>
      );
    }
  },
  {
    id: map.ASSET_TYPE,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Asset Type",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ASSET_TYPE);

      return (<TableRow>
        <TableCell>Asset Type</TableCell>
        <TableCell>{value}</TableCell>
      </TableRow>);
    }
  },
  {
    id: map.ASSET_CLASS,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Asset Class",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ASSET_CLASS);

      return (
        <TableRow>
          <TableCell>Asset Class</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>
      );
    }
  },
  {
    id: map.SQUARE_FEET,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Square Feet",
    Cell: data => {
      const value = getMetricValue(data.deal, map.SQUARE_FEET);

      return (
        <TableRow>
          <TableCell>Square Feet</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>
      );
    }
  },
  {
    id: map.MF_UNITS,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "MF Units",
    Cell: data => {
      const value = getMetricValue(data.deal, map.MF_UNITS);

      return (
        <TableRow>
          <TableCell>MF Units</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>);
    }
  },
  {
    id: map.CITY,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "City",
    Cell: data => {
      const value = getMetricValue(data.deal, map.CITY);

      return (
        <TableRow>
          <TableCell>City</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>);
    }
  },
  {
    id: map.STATE,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "State",
    Cell: data => {
      const value = getMetricValue(data.deal, map.STATE);

      return (<TableRow>
        <TableCell>State</TableCell>
        <TableCell>{value}</TableCell>
      </TableRow>);
    }
  },
  {
    id: map.TEAM_MEMBER,
    isBaseColumn: false,
    dataField: "teamMember",
    numeric: false,
    label: "Team Member",
    Cell: ({ deal: { teamMember } }) => <TableRow>
      <TableCell>Team Member</TableCell>
      <TableCell>{teamMember ? `${teamMember.firstName} ${teamMember.lastName}` : "\u2014"}</TableCell>
    </TableRow>
  },
  {
    id: map.LOAN_SPREAD,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Loan Spread",
    Cell: data => {
      const value = getMetricValue(data.deal, map.LOAN_SPREAD);

      return (<TableRow>
        <TableCell>Loan Spread</TableCell>
        <TableCell>{value}</TableCell>
      </TableRow>);
    }
  },
  {
    id: map.ALL_IN_RATE,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "All-In Rate",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ALL_IN_RATE);

      return (<TableRow>
        <TableCell>All-In Rate</TableCell>
        <TableCell>{value}</TableCell>
      </TableRow>);
    }
  },
  {
    id: map.LENDER,
    isBaseColumn: false,
    dataField: null,
    numeric: false,
    label: "Lender",
    Cell: data => {
      const value = getMetricValue(data.deal, map.LENDER);

      return (
        <TableRow>
          <TableCell>Lender</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>);
    }
  }
];

export default PipelineDealTileRows;
